// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-listitem_default__1asom","bordered":"idt-listitem_bordered__3qobs"};